import { ApButtonDanger } from '@alixpartners/ui-components';
import { VendorFileArchiveContext } from 'contexts/VendorFileArchiveContext';
import { PERMISSIONS, PermissionsContext } from 'contexts/PermissionsContext';
import React from 'react';
import {
	BottomSection,
	Content,
	Description,
	Section,
	Sidebar,
	Title,
	Wrapper,
} from './VendorCleanup.styles';
import { daleteVendorData } from 'utils/apiRequests';
import { useState } from 'react';
import VendorData from './VendorData/VendorData';
import { UploadVendorStateContext } from 'contexts/UploadVendorStateContext';
import DeleteAllVendorDataModal from 'Data/components/DeleteVendorDataModal';

const VendorCleanup = ({ permissions, status, fetchFileArchive }) => {
	const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
	const [isDeleting, setIsDeleting] = useState(false);
	const canDeleteAllData = permissions.includes(
		PERMISSIONS.TransactionsDeleteAll
	);

	const handleDeleteAllData = () => {
		setIsDeleting(true);
		daleteVendorData()
			.then(response => {
				if (response.statusCode === 200) {
					setIsDeleting(false);
					setDeleteModalOpen(false);
					fetchFileArchive();
				}
			})
			.catch(() => {
				setIsDeleting(false);
			});
	};

	return (
		<Wrapper>
			<Sidebar>
				<Section>
					<Title>Data upload</Title>
					<Description>
						<p>Data upload process:</p>
						<p>1. Upload file into the system</p>
						<p>2. Configure set up</p>
						<p>3. Cleanup vendor names</p>
					</Description>
				</Section>
				{canDeleteAllData && (
					<BottomSection>
						<Title>Delete data</Title>
						<Description>
							Data deletion clears Normalization history
						</Description>
						<ApButtonDanger
							iconName="delete"
							onClick={e => {
								e.preventDefault();
								setDeleteModalOpen(true);
							}}
						>
							Delete History
						</ApButtonDanger>
					</BottomSection>
				)}
			</Sidebar>
			<Content>
				<VendorData status={status} />
			</Content>
			{canDeleteAllData &&
				isDeleteModalOpen && (
					<DeleteAllVendorDataModal
						onConfirm={handleDeleteAllData}
						onCancel={() => (!isDeleting ? setDeleteModalOpen(false) : null)}
						inProgress={isDeleting}
					/>
				)}
		</Wrapper>
	);
};

export default props => (
	<VendorFileArchiveContext.Consumer>
		{({ fileArchive, refetch }) => (
			<UploadVendorStateContext.Consumer>
				{({ vendorStatus }) => (
					<PermissionsContext.Consumer>
						{({ permissions }) => (
							<VendorCleanup
								{...props}
								permissions={permissions || []}
								status={vendorStatus}
								fileArchive={fileArchive}
								fetchFileArchive={refetch}
							/>
						)}
					</PermissionsContext.Consumer>
				)}
			</UploadVendorStateContext.Consumer>
		)}
	</VendorFileArchiveContext.Consumer>
);
